module.exports = __webpack_public_path__ + "img/lk-menu-key.95b9923a.svg";